import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../app/hooks';
import { sendBulkAddNotification } from '../../store/investor/apiHelpers';
import { Mixpanel } from '../../utils/mixpanel';
import { BULK_ADD_CONFIRM } from '../../utils/constants/mixpanelEvents/investorEvents';

export const useBulkAddModalLogic = (initialText: string, onClose: () => void) => {
    const [bulkText, setBulkText] = useState(initialText);
    const [bulkLoading, setBulkLoading] = useState(false);
    const hasUserEditedRef = useRef(false);

    const userName = useAppSelector((state) => state.user.userData?.userName);
    const userEmail = useAppSelector((state) => state.user.userData?.primaryEmail);
    const pnoId = useAppSelector((state) => state.user.userData?.investorOrgId);
    const pnoName = useAppSelector((state) => state.user.userData?.pnoName);

    // Re-sync from initialText while the textarea is still untouched, so late-arriving async
    // prefill fields (e.g. website/brand resolved in a phase-2 dispatch) populate.
    useEffect(() => {
        if (!hasUserEditedRef.current) {
            setBulkText(initialText);
        }
    }, [initialText]);

    const trackBulkConfirmEvent = (text: string) => {
        const count = text.split(',').filter((value) => value.trim().length > 0).length;

        Mixpanel.track(BULK_ADD_CONFIRM, {
            User_Name: userName,
            User_Email: userEmail,
            PNO_ID: pnoId,
            PNO_Name: pnoName,
            Bulk_Input_Count: count,
        });
    };

    const handleBulkConfirm = async () => {
        try {
            setBulkLoading(true);

            await sendBulkAddNotification({
                userName: userName || '',
                userEmail: userEmail || '',
                pnoId: pnoId || '',
                pnoName: pnoName || '',
                bulkInputText: bulkText,
            });

            trackBulkConfirmEvent(bulkText);
            setBulkText('');
            onClose();
        } catch (error) {
            console.error('Bulk notification failed', error);
            toast.error('Something went wrong while submitting. Please try again.');
        } finally {
            setBulkLoading(false);
        }
    };

    return { bulkText, setBulkText, bulkLoading, handleBulkConfirm, hasUserEditedRef };
};
